export type Offset = {
  x: number
  y: number
}

type CreationOffset = keyof typeof offsetMap

const offsetMap = {
  TOP: { x: 0, y: -1 },
  RIGHT: { x: 1, y: 0 },
  BOTTOM: { x: 0, y: 1 },
  LEFT: { x: -1, y: 0 },
  TOP_RIGHT: { x: 1, y: -1 },
  TOP_LEFT: { x: -1, y: -1 },
  BOTTOM_RIGHT: { x: 1, y: 1 },
  BOTTOM_LEFT: { x: -1, y: 1 },
}

export const getRandomPositionWithOffset = ([x, y, width, height]: [
  number,
  number,
  number,
  number,
]): Offset => {
  const positions: CreationOffset[] = Object.keys(offsetMap) as CreationOffset[]

  const randomIndex = Math.floor(Math.random() * positions.length)
  const pos = positions[randomIndex]

  const gap = Math.floor(Math.random() * 100)

  const offset = offsetMap[pos]

  const result: Offset = {
    x: x + offset.x * (width + gap),
    y: y + offset.y * (height + gap),
  }

  return result
}
